<template>
    <div class="table-scroll-header" :style="{ top: stickyOffset + 'px' }">
        <div class="scroll-buttons">
            <button
                type="button"
                class="scroll-btn"
                @click="$emit('scroll-left')"
                :disabled="!canScrollLeft"
                aria-label="Scroll table left"
            >
                <font-awesome-icon :icon="['fas', 'chevron-left']" />
            </button>
            <button
                type="button"
                class="scroll-btn"
                @click="$emit('scroll-right')"
                :disabled="!canScrollRight"
                aria-label="Scroll table right"
            >
                <font-awesome-icon :icon="['fas', 'chevron-right']" />
            </button>
        </div>
        <div class="scroll-progress" aria-hidden="true">
            <div class="scroll-progress__bar" :style="{ width: scrollPercent + '%' }"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TableScrollHeader',
        props: {
            canScrollLeft: {
                type: Boolean,
                default: false,
            },
            canScrollRight: {
                type: Boolean,
                default: false,
            },
            scrollPercent: {
                type: Number,
                default: 0,
            },
            stickyOffset: {
                type: Number,
                default: 70,
            },
        },
    }
</script>

<style scoped lang="scss">
    .table-scroll-header {
        position: sticky;
        z-index: 7;
        display: flex;
        align-items: center;
        gap: 0.75rem;
        margin-bottom: 0.4rem;
        padding: 0.25rem 0;
        background: var(--color-surface-canvas);
        box-shadow: var(--shadow-sm);
    }

    .scroll-buttons {
        display: inline-flex;
        gap: 0.35rem;
    }

    .scroll-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 34px;
        height: 34px;
        border: 1px solid var(--color-border-default);
        border-radius: 8px;
        background: var(--color-surface-canvas);
        color: var(--color-text-primary);
        box-shadow: var(--shadow-xs);
        transition: all 0.15s ease;

        &:hover:enabled {
            border-color: var(--color-text-muted);
            background: var(--color-surface-subtle);
        }

        &:disabled {
            opacity: 0.45;
            cursor: not-allowed;
        }
    }

    .scroll-progress {
        position: relative;
        flex: 1;
        height: 8px;
        border-radius: var(--radius-pill);
        background: var(--color-border-muted);
        overflow: hidden;
    }

    .scroll-progress__bar {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 0%;
        background: linear-gradient(
            90deg,
            var(--color-brand-primary),
            var(--color-brand-primary-soft)
        );
        transition: width 0.2s ease;
    }
</style>
